import styled, { css } from 'styled-components';

import {
  spacingStyles,
  StyledSpacingProps,
  StyledTextProps,
  textStyles,
} from '../../../../styles';
import { borderRadius, spacing } from '../../../../theme';
import { NumericInputClassNames } from '../../../NumericInput/constants';
import NumericInput from '../../../NumericInput/NumericInput';

import { DataTableCellEditorVariableNames } from './constants';

const noBorderStyles = css`
  border-radius: ${borderRadius.none};
  border: none;
  box-shadow: none;
  outline: none;
`;

const DataTableCellNumericInput = styled(NumericInput).attrs({
  isLabelHidden: true,
  isErrorHidden: true,
  autoFocus: true,
  elementSize: 'small',
})<StyledSpacingProps & StyledTextProps>`
  box-sizing: border-box;
  height: 100%;
  width: 100%;
  padding: ${spacing['8x']} ${spacing['12x']};

  ${noBorderStyles}

  .${NumericInputClassNames.MainWrapper}, .${NumericInputClassNames.MaskWrapper} {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    padding: 0;
    ${noBorderStyles}
  }

  .${NumericInputClassNames.Main} {
    box-sizing: border-box;
    padding: 0;
    ${noBorderStyles}
  }

  .${NumericInputClassNames.Main}, .${NumericInputClassNames.Mask} {
    font-weight: var(${DataTableCellEditorVariableNames.FontWeight});
    font-size: var(${DataTableCellEditorVariableNames.FontSize});
    ${textStyles}
  }

  ${spacingStyles}
`;

export default DataTableCellNumericInput;
